import _ from 'lodash';
import React from 'react';
import {
  FormField,
  HelpBlock,
  Textarea,
  Label,
  Row,
} from '../../common/form';
import FundContext from './context';

export default function withNameTextarea(name, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);

  function PlainInput() {
    const { state, dispatch } = React.useContext(FundContext);

    const handleChange = e => {
      const v = _.get(e, 'target.value', '');
      dispatch({ type: `set${capitalize}`, payload: v });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <Textarea
            id={kebab}
            name={name}
            value={state.fund[name]}
            onChange={handleChange}
          />
          {state.errors[name] && <HelpBlock>{state.errors[name]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainInput.displayName = capitalize;

  return PlainInput;
}
